import { render } from "./ActivateRequest.vue?vue&type=template&id=43712fba"
import script from "./ActivateRequest.vue?vue&type=script&lang=js"
export * from "./ActivateRequest.vue?vue&type=script&lang=js"
script.render = render

export default script